import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrackerService } from 'src/app/repository/service/tracker.service';
import { InsightsService } from 'src/app/shared/insights/service/insights.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { QualService } from '../service/qual.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-qual-list',
  templateUrl: './qual-list.component.html',
  styleUrls: ['./qual-list.component.scss']
})

// interface TableData {
//   slNo: number;
//   name: string;
//   gender: string;
//   age: number;
//   city: string;
// }

export class QualListComponent implements OnInit, OnDestroy {
  public isInterviewExpanded: boolean = false;
  public isTranslatorExpand: boolean = false;
  public isCoordinatorExpand: boolean = false;
  public isModeratorExpand: boolean = false;

  

  constructor(public QService:QualService,
    public sidePanelService:SidePanelService,
    public homeService: HomeService,
    public iService:InsightsService,
    public router:Router,
    public trackerService:TrackerService, 
    private notifier: NotifierService) {
    // this.sidePanelService.initSideDrawer('home');
    this.homeService.isOpen = true;
    this.QService.getInterviewList();
  }

  // displayedColumns: string[] = ['slNo', 'id', 'gender', 'age', 'city'];
  displayedColumns: string[] = ['interview_id', 'id', 'gender', 'age', 'city'];


  ngOnInit() : void{
    this.QService.selectedInterview = null;
    this.QService.getStudyId();
    this.sidePanelService.initSideDrawer('qual');
    this.homeService.checkRepoDetailsEvent.emit(this.QService.studyId);
    // this.sidePanelService.getVisibility(this.QService.studyId);
  }

  ngOnDestroy(){
    this.QService.interviewData = [];
    this.QService.studyName = '';
  }

  selectInterview(interview){
    if ((interview.status == 'On Going' || interview.join_now) && interview.url && interview.url !='') {
      // window.location.href = interview.url;
      let data = {}
      data['uuid'] = interview.uuid;
      data['file_type'] = 'interview';
      data['action'] = 'join';
      // data['misc'] = {'action':'join'};
      // console.log("interview == ",interview)
      this.trackerService.submitTracker(data);
      if(interview && interview.clientId && interview.clientId != ''){
        // this.router.navigate(['/consumervoice/interview/q?token=',interview.clientId])
        // this.router.navigate(['/consumervoice/interview/q'],{queryParams: {token: interview.clientId}});
        // this.router.navigate(['/consumervoice/interview/',interview.clientId])
        const url = this.router.createUrlTree(['/consumervoice/interview/q'], { queryParams: { token: interview.clientId } }).toString();
        window.open(url, '_blank');
      }else{
        this.notifier.notify('error','Client Id not found!');
      }
      // window.open(interview.url);
    }else if (interview.status == 'Completed') {
      this.QService.selectedInterview = interview;
      this.router.navigate(['/qual/report',this.QService.studyId]);
      // this.router.navigate(['/home/qual/report',this.QService.studyId]);
    }
  }
  openInvite(interviewUuid){
    this.QService.interviewUuid = interviewUuid;
    this.QService.isOpenInvite = true;
  }

  getModifyContent(content: string[],expand:boolean): string {
    return expand ? content.join(', ') : content.slice(0, 4).join(', ');
  }

  getExpandedContent(content: string[],expand): string {
    return expand ? "View Less" :  '+' + (content.length - 4) + ' More';
  }
  
  openAiDiscussion(interview){

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/qual/discussion-guide/', interview.uuid])
    );
    window.open(url, '_blank');
    // this.router.navigate(['/qual/discussion-guide/',interview.uuid]);
  }
}
